import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FloatingShapes } from '@ui/FloatingShapes';

export const HomePage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="h-screen flex flex-col bg-gradient-to-br from-blue-600 to-purple-700 text-white relative overflow-hidden">
      {/* ===== Hero 区域 ===== */}
        <FloatingShapes />      

        {/* 顶部导航 */}
        <nav className="relative z-10 flex items-center justify-between px-6 py-4 sm:px-12">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 bg-white rounded-xl flex items-center justify-center shadow">
              <img src="/logo.png" alt="Logo" className="w-6 h-6" />
            </div>
            <span className="text-lg font-bold">AI少儿编程</span>
          </div>
          <div className="flex items-center gap-3">
            <button
              onClick={() => navigate('/login')}
              className="px-4 py-2 text-sm font-medium text-white/90 hover:text-white transition-colors"
            >
              
            </button>
            <button
              onClick={() => navigate('/register')}
              className="px-4 py-2 text-sm font-medium bg-white text-blue-600 rounded-lg hover:bg-gray-100 transition-colors"
            >
              注册
            </button>
          </div>
        </nav>

        {/* Hero 内容 */}
        <div className="flex-1 flex items-center justify-center px-6 sm:px-12 py-8 relative z-10 overflow-hidden">
          <div className="text-center max-w-3xl">
            <h1 className="text-4xl sm:text-5xl md:text-6xl font-bold mb-6 leading-tight">
              AI少儿编程学习平台
            </h1>
            <p className="text-lg sm:text-xl md:text-2xl text-blue-100 mb-10 leading-relaxed">
              通过有趣的AI项目，让孩子们轻松学习编程和人工智能
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
              <button
                onClick={() => navigate('/login')}
                className="w-full max-w-[240px] sm:w-auto px-8 py-3.5 bg-blue-600 text-white text-lg font-semibold rounded-xl hover:bg-gray-100 hover:text-blue-600 transition-colors shadow-lg"
              >
                用户进入
              </button>
              <button
                onClick={() => navigate('/guest')}
                className="w-full max-w-[240px] sm:w-auto px-8 py-3.5 border-2 border-white/60 bg-white text-blue-600 text-lg font-semibold rounded-xl hover:bg-white/10 transition-colors"
              >
                访客浏览
              </button>
            </div>
          </div>
        </div>

        {/* 页脚（固定在底部） */}
        <footer className="shrink-0 relative z-10 text-white/70 py-4 text-center">
          <div className="max-w-6xl mx-auto px-6 sm:px-12 text-center">
            <p className="text-sm">&copy; 2025AI少儿编程学习平台</p>
            <p className="text-xs mt-1">
              <a 
                href="https://beian.miit.gov.cn/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="hover:text-gray-300 transition-colors"
              >
                京ICP备2025152547号
              </a>
            </p>
          </div>
        </footer>
    </div>
  );
};
